import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './CommonDialogWindowComponentStyles.scss'; 
interface CommonDialogWindowConfig {
    title: string;
    open: boolean;
    message: string;
    hideYes: boolean;
    hideNo: boolean;
    yesButtonLabel: string;
    noButtonLabel: string;
    onClose: (result: boolean) => void;
}

const CommonDialogWindowComponent = React.forwardRef<any, {}>((_props, dialogRef) => {
    const [dialogConfig, setDialogConfig] = React.useState<CommonDialogWindowConfig>();

    React.useImperativeHandle(dialogRef, () => ({
        setDialogConfig,
    }));
    return (
        <Dialog
            ref={dialogRef}
            visible={dialogConfig?.open ?? false}
            onHide={() => setDialogConfig(undefined)}
            header={dialogConfig?.title}
            footer={
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
               { !dialogConfig?.hideYes && <Button label={dialogConfig?.yesButtonLabel ?? "Yes"} className="yesButton" onClick={() => { setDialogConfig(undefined); dialogConfig?.onClose(true); }} autoFocus />}
               { !dialogConfig?.hideNo && <Button label={dialogConfig?.noButtonLabel ?? "No"} className="noButton" onClick={() => { setDialogConfig(undefined); dialogConfig?.onClose(false); }} /> }
            </div>
            }
            style={{ width: '30vw', top: '5vh' }}
            className="custom-dialog"
            position="top"
            modal
        >
            <div className="confirmationfont" style={{ fontSize: '1.1rem', padding: '1rem 0' }}>
            {dialogConfig?.message}
            </div>
        </Dialog>
    );
});

export default CommonDialogWindowComponent;